// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"c6a09675","753":"bf5ec828","787":"b5190052"}[chunkId] + ".chunk.js";
};